import _, { isArray } from 'lodash'
import {
  Bar,
  ComposedChart,
  LabelList,
  LabelProps,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import { Typography, useTheme } from '@mui/material'
import { Container } from './styles'
import {
  TooltipGraph,
  ViewDataError,
  ViewDataLoading,
} from '../../../../../components'
import {
  checkInstitutionsListGraphsStatus,
  formatNumberTimeMsToScale,
} from '../../../../../utils'
import { SelectDefaultValue } from '../../../../../domain'

const PercentLabel = ({ x, y, width, value }: LabelProps) => {
  const _value = formatNumberTimeMsToScale(Number(value))
  const _plus =
    _value.length === 7
      ? 35
      : _value.length === 8
      ? 40
      : _value.length === 9
      ? 50
      : 30
  const _x = Number(x) + Number(width) + _plus
  const _y = Number(y) + 11

  return (
    <g>
      <text
        x={_x}
        y={_y}
        fill="#000"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {_value}
      </text>
    </g>
  )
}

const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    return (
      <TooltipGraph>
        <Typography>Sociedade: {payload[0].payload.serverName}</Typography>
        <Typography>
          Média: {formatNumberTimeMsToScale(payload[0].value)}
        </Typography>
      </TooltipGraph>
    )
  }
  return null
}

interface AverageResponseTimePageFourProps {
  data: any
  chartOrder: SelectDefaultValue
  mobile: boolean
  loading: boolean
}
const AverageResponseTimePageFour = ({
  data,
  chartOrder,
  mobile,
  loading,
}: AverageResponseTimePageFourProps) => {
  const theme = useTheme()
  const filteredData = isArray(data)
    ? data?.filter((item: any) => item.response > 0)
    : []
  const status = checkInstitutionsListGraphsStatus(data, loading, filteredData)

  return (
    <>
      {loading && <ViewDataLoading />}

      {!loading && (!data || data.length === 0 || status === 'NODATA') && (
        <ViewDataError />
      )}

      {status === 'HASDATA' && data && data.length > 0 && !loading && (
        <Container mobile={mobile} sx={{ maxHeight: 380 }}>
          <ResponsiveContainer
            minWidth={500}
            minHeight={filteredData.length > 4 ? filteredData.length * 70 : 280}
          >
            <ComposedChart
              layout="vertical"
              barCategoryGap="20%"
              data={_.orderBy(
                filteredData,
                [chartOrder.value.by],
                [chartOrder.value.type],
              )}
            >
              <XAxis
                type="number"
                hide={true}
                domain={[0, (dataMax: number) => dataMax * 1.8]}
                scale="sqrt"
              />
              <YAxis
                dataKey="serverName"
                type="category"
                width={200}
                tickLine={false}
                interval={0}
                fontSize={12}
              />
              <Bar
                isAnimationActive={false}
                dataKey="response"
                fill={theme.palette.primary.light}
                barSize={20}
              >
                <LabelList
                  dataKey="response"
                  position="right"
                  content={PercentLabel}
                />
              </Bar>
              {!mobile && <Tooltip content={<CustomTooltip />} />}
            </ComposedChart>
          </ResponsiveContainer>
        </Container>
      )}
    </>
  )
}

export default AverageResponseTimePageFour
